export function daysRemainingStr(daysVal) {
  if (daysVal === 1) {
    return '1 day remaining';
  } else if (daysVal) {
    return daysVal.toLocaleString() + ' days remaining';
  }
  return '';
}
